<template>
	<v-card elevation="0" class="ant-card mt-6 pa-4">
		<v-card-title class="pa-0 d-flex align-center">
			<div class="v-typography--title1">{{ $t("variants") }}</div>
			<v-spacer />
			<v-btn outlined text @click="$emit('add')">
				<v-icon size="15" left>icon-plus</v-icon>
				<span class="v-typography--body-sm">{{ $t("add_variant") }}</span>
			</v-btn>
		</v-card-title>
		<v-divider class="my-3" />
		<v-simple-table dense>
			<thead>
				<tr>
					<th>{{ $t("code") }}</th>
					<th>{{ $t("name") }}</th>
					<th>{{ $t("measurements") }}</th>
					<th>{{ $t("attributes") }}</th>
					<th class="text-right">{{ $t("actions") }}</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(variant, i) in variants" :key="variant._id">
					<td>{{ variant.code }}</td>
					<td>{{ variant.name[lang] || variant.name._default }}</td>
					<td>
						<div v-for="(m, mi) in variant.measurements" :key="mi">
							<span v-for="(val, key, idx) in filteredMeasurementObject(m)" :key="key">
								{{ val }}<span v-if="idx < Object.keys(filteredMeasurementObject(m)).length - 1"> × </span>
							</span>
							<span v-if="m.unit">{{ m.unit }}</span>
							<span class="grey--text">({{ m.format }})</span>
						</div>
					</td>
					<td>
						<div v-for="av in variant.attributes" :key="av.attributeId">
							<span v-if="av.labelOnly">{{ av.attributeName }}</span>
							<span v-else>{{ av.attributeName }}: {{ av.renderedValue }}</span>
						</div>
					</td>
					<td class="text-right">
						<v-btn small icon @click="$emit('edit', variant, i)">
							<v-icon size="18">icon-edit</v-icon>
						</v-btn>
						<v-btn icon small @click="$emit('delete', i)">
							<v-icon size="18" color="red">icon-delete</v-icon>
						</v-btn>
					</td>
				</tr>
			</tbody>
		</v-simple-table>
	</v-card>
</template>

<script>
export default {
	name: "ProductVariants",
	props: {
		variants: { type: Array, required: true },
		lang: { type: String, required: true },
		filteredMeasurementObject: { type: Function, required: true },
	},
};
</script>
